"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingSpecificationError = exports.SHIPPING_SPECIFICATION_SOURCE_TYPE_RANKING = exports.ShippingSpecificationSourceType = void 0;
var ShippingSpecificationSourceType;
(function (ShippingSpecificationSourceType) {
    ShippingSpecificationSourceType["MANUAL"] = "MANUAL";
    ShippingSpecificationSourceType["HAZMAT"] = "HAZMAT";
    ShippingSpecificationSourceType["SELLER"] = "SELLER";
})(ShippingSpecificationSourceType = exports.ShippingSpecificationSourceType || (exports.ShippingSpecificationSourceType = {}));
exports.SHIPPING_SPECIFICATION_SOURCE_TYPE_RANKING = [
    ShippingSpecificationSourceType.SELLER,
    ShippingSpecificationSourceType.HAZMAT,
    ShippingSpecificationSourceType.MANUAL,
];
var ShippingSpecificationError;
(function (ShippingSpecificationError) {
    ShippingSpecificationError["INVALID_PACKAGING_TYPE"] = "INVALID_PACKAGING_TYPE";
    ShippingSpecificationError["INVALID_SOURCE"] = "INVALID_SOURCE";
    ShippingSpecificationError["MISSING_SOURCE_USER"] = "MISSING_SOURCE_USER";
})(ShippingSpecificationError = exports.ShippingSpecificationError || (exports.ShippingSpecificationError = {}));
//# sourceMappingURL=ShippingSpecification.js.map